export default {
  home: {
    title: '首页',
    search: '搜索网站...',
    popularSearch: '热门搜索',
    categories: '网站分类',
    featuredSites: '精选推荐网站',
    articles: '精选推荐文章',
    submitSite: '提交网站',
  },
  category: {
    hotRecommend: '热门推荐',
    newest: '最新收录',
    viewAll: '查看全部',
    otherCategories: '浏览其他分类',
  },
  article: {
    relatedArticles: '相关文章',
    backHome: '返回首页',
    shareTo: '分享到',
  },
  about: {
    aboutUs: '关于我们',
    brandIntro: '品牌介绍',
    mission: '我们的使命',
    vision: '我们的愿景',
    reputation: '用户口碑',
    faq: '常见问题',
    contactUs: '联系我们',
    sendMessage: '发送消息',
    name: '姓名',
    email: '邮箱',
    subject: '主题',
    message: '消息内容',
  },
  footer: {
    quickLinks: '快速链接',
    hotCategories: '热门分类',
    contact: '联系方式',
    rights: '版权所有',
    privacy: '隐私政策',
    terms: '使用条款',
    sitemap: '网站地图',
  },
};